import FJModal from '../FJModal';
import FJProgressModal from './FJProgressModal';
import useLocalStore from '../../../hooks/useLocalStore';
import FJLocalStore from '../../../store/FJLocalStore';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { FJModalsAction } from '@src/redux/action/FJModalsAction.ts';
import FJEventBridge from '@src/manager/FJEventBridge.ts';
import FJEventBridgeManager, { FJEventBridgeTarget } from '@src/manager/FJEventBridgeManager.ts';

export default function FJProgressModalContainer() {
    useLocalStore();
    const dispatch = useAppDispatch();
    const { display, messageKey, hint, progress } = useAppSelector(state => state.modals.progressModalData);

    const _onClose = () => {
        const b: FJEventBridge = FJEventBridgeManager.getBridge(FJEventBridgeTarget.PROGRESS_MODAL);
        b.execute();
        FJEventBridgeManager.removeBridge(FJEventBridgeTarget.PROGRESS_MODAL);
        dispatch(FJModalsAction.hideProgressModalAction());
    };

    return (
        <FJModal visible={display}>
            <FJProgressModal
                title={messageKey ? FJLocalStore._(messageKey) : ''}
                hint={hint}
                progress={progress}
                onClose={_onClose}
            />
        </FJModal>
    );
}
